// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-insurance-personal-v3/form-item-insurance-personal-v3.component.scss
// module id = 923
// module chunks = 0